var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHomeNotSmoke = function SvgHomeNotSmoke(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    "aria-hidden": "true",
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-naki08-MuiSvgIcon-root e1de0imv0",
    color: "#7d7d7d",
    "data-tooltip": "circuit-card-icon",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    "aria-hidden": "true",
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root e1de0imv0",
    "data-testid": "CottageRoundedIcon",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M9.456 1.356q0 .003-.003.005h.008zm2.535 1.902a.98.98 0 0 0-.6.202L6 7.58V7c0-.55-.45-1-1-1s-1 .45-1 1v2.11l-2.21 1.68c-.44.33-.52.96-.19 1.4.34.44.96.52 1.4.19l1-.76V20c0 .55.45 1 1 1h6v-5c0-.55.45-1 1-1s1 .45 1 1v5h6c.55 0 1-.45 1-1v-8.38l.99.76a.993.993 0 0 0 1.4-.19.993.993 0 0 0-.19-1.4l-9.6-7.33a1 1 0 0 0-.609-.202z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHomeNotSmoke);
export default ForwardRef;